module.exports = __webpack_public_path__ + "img/noData1.e8bc9e97.svg";